import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import axios from "axios";
import { axiosErrorHandler } from "../../../../swzutils";
import { Spin } from "antd";
const VehicleHireDriverSummary = ({ vehicleHireId, onDriverLoaded }) => {
    const [loading, setLoading] = useState(false);
    const [driver, setDriver] = useState(null);
    useEffect(() => {
        if (vehicleHireId) {
            loadDriver();
        }
    }, [vehicleHireId]);
    const loadDriver = () => {
        setLoading(true);
        axios.get(`/admin/v1/vehicle-hires/${vehicleHireId}/driver`).then(response => {
            setDriver(response.data);
            onDriverLoaded && onDriverLoaded(response.data);
        }).catch((error) => {
            if (error.response.status !== 404) {
                axiosErrorHandler(error);
            }
        }).finally(() => setLoading(false));
    };
    return (_jsx(Spin, { spinning: loading, children: (driver?.id) ?
            _jsxs("dl", { children: [_jsx("dt", { children: "Name" }), _jsxs("dd", { children: [driver.firstName, " ", driver.lastName] }), _jsx("dt", { children: "Mobile Telephone" }), _jsx("dd", { children: driver.mobileNo }), _jsx("dt", { children: "Email" }), _jsx("dd", { children: (driver.emailAddress)
                            ? _jsx("span", { children: driver.emailAddress })
                            : _jsx("span", { children: "\u2014" }) })] })
            : _jsx("p", { children: "No driver" }) }));
};
export default VehicleHireDriverSummary;
